import {Component} from "../../../../sedestral/framework/interface/component/Component";
import * as s from "./empty.scss";
import {Network} from "../../../../network/Network";
import {LoaderLightComponent} from "../loader/light/LoaderLightComponent";

export class EmptyBasicComponent extends Component {

    public buttonContainer: Component;
    public button: Component;

    public textContainer: Component;

    public loading: Component;
    public buttonBlack: boolean;

    constructor(emoji: string, text: string, buttonText?: string, loader?: boolean, buttonBlack?: boolean) {
        super();
        this.buttonBlack = buttonBlack;

        //language=HTML
        this.template = `
            <div emptyBasic class="${s.globalEmptyBasic}">
                <div class="${s.emptyContent}">
                    <div emptyemoji class="${s.emoji}">${emoji}</div>
                    ${text == undefined ? `` : `<div emptyText class="${s.text}">${text}</div>`}
                    ${buttonText == undefined ? `` : `<div class="${s.buttonContainer}"><div emptyButton class="${s.button} ${buttonBlack ? s.black : ``}">${buttonText}${buttonBlack ? `<div class="${s.icon}"></div>`:``}</div></div>`}
                    ${loader == undefined ? `` : `<div class="${s.loader}">${this.draw(new LoaderLightComponent({
                        width: 50,
                        strokeWidth: 3
                    }))}</div>`}
                </div>
            </div>
        `;
    }

    commit() {
        this.buttonContainer = this.el(s.buttonContainer);
        this.button = this.el(s.button);
        this.textContainer = this.el(s.text);

        if (this.buttonContainer && !this.buttonContainer.isNull()) {
            this.buttonContainer.onClick(() => {
                if (!this.button.hasClass(s.loading))
                    this.onButtonClick()
            });
        }

        super.commit();
    }

    onButtonClick() {

    }

    setButtonLoading() {
        if (!this.buttonContainer.isNull()) {
            // sans strokeColor le trait est var(--black) par défaut → invisible sur un bouton noir ; on l'adapte au thème
            this.loading = this.button.render(new LoaderLightComponent({
                width: 20,
                strokeColor: this.buttonBlack ? "var(--white)" : "var(--black)"
            }));
            this.button.addClass(s.loading);
        }
    }

    remButtonLoading() {
        if (!this.buttonContainer.isNull() && this.loading) {
            this.button.removeClass(s.loading);
            this.loading.remove();
            this.loading = undefined;
        }
    }
}